export default __webpack_public_path__ + "static/media/82.a89f3cdc.jpg";